import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { BomAttachmentListDto } from './models/bom-attachment-list.dto';
import { AttachmentKind } from './documents.store';

@Injectable({ providedIn: 'root' })
export class DocumentsProvider {
  constructor(private http: HttpClient) {}

  getAttachmentList(search?: string, type?: AttachmentKind, page?: number, pageSize?: number): Observable<BomAttachmentListDto> {
    const url = '/api/bom/attachments';

    const params: { search?: string, type?: string, page?: number, pageSize?: number } = {};

    if (search) {
      params.search = search;
    }

    if (type) {
      params.type = type;
    }

    if (page) {
      params.page = page;
    }

    if (pageSize) {
      params.pageSize = pageSize;
    }

    return this.http.get<BomAttachmentListDto>(url, { params });
  }

  // the ZAŁĄCZNIKI card's link: the file itself, opened in a new tab
  contentUrl(attachmentId: number): string {
    return `/api/bom/attachments/${attachmentId}/content`;
  }
}
